

export enum ImporterType {
    Vehicle,
    Product,
    Regular,
    Enterprise
}

export enum ImportToType {
    Canada,
    Usa
}



// WEBPACK FOOTER //
// ./app/objects/calculator/public/types/type.ts